import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'leaves/'

const initialState = {
    leaves: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

// ===== Async Thunks =====
export const getLeaves = createAsyncThunk('leaves/getAll', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSingleleave = createAsyncThunk('leaves/getSingle', async (id, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}/${id}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addLeave = createAsyncThunk('leaves/add', async (leaveData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL, leaveData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const editLeave = createAsyncThunk('leaves/edit', async (leaveData, thunkAPI) => {
    try {
        const result = await axios.put(`${API_URL}/${leaveData.id}`, leaveData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteLeave = createAsyncThunk('leaves/delete', async (id, thunkAPI) => {
    try {
        const result = await axios.delete(`${API_URL}/${id}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

// ===== Slice =====
export const leaveSlice = createSlice({
    name: 'emp',
    initialState,
    reducers: {
        reset: (state) => {
            state.leaves = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }
    },
    extraReducers: (builder) => {
        // ===== getLeaves =====
        builder
            .addCase(getLeaves.pending, (state) => { state.isLoading = true })
            .addCase(getLeaves.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.leaves = action.payload
            })
            .addCase(getLeaves.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.leaves = []
            })

        // ===== getSingleleave =====
            .addCase(getSingleleave.pending, (state) => { state.isLoading = true })
            .addCase(getSingleleave.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                // single leave can be used in form, no array change
            })
            .addCase(getSingleleave.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

        // ===== addLeave =====
            .addCase(addLeave.pending, (state) => { state.isLoading = true })
            .addCase(addLeave.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.leaves.push(action.payload) // add to list
            })
            .addCase(addLeave.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

        // ===== editLeave =====
            .addCase(editLeave.pending, (state) => { state.isLoading = true })
            .addCase(editLeave.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                const index = state.leaves.findIndex(l => l.leaveID === action.payload.leaveID)
                if (index !== -1) state.leaves[index] = action.payload
            })
            .addCase(editLeave.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

        // ===== deleteLeave =====
            .addCase(deleteLeave.pending, (state) => { state.isLoading = true })
            .addCase(deleteLeave.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                // remove deleted leave from array if id exists
                state.leaves = state.leaves.filter(l => l.leaveID !== action.meta.arg)
            })
            .addCase(deleteLeave.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = leaveSlice.actions
export default leaveSlice.reducer
